import Client from './client';

export default class AlertFailureSummaries extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(options = {}) {
    return this.makeRequest(`${this.host}/internal/stats/events/failures/summaries`, options);
  }

  getByDb(db, options = {}) {
    return this.makeRequest(`${this.host}/internal/stats/events/failures/summaries/${db}`, options);
  }

  deleteByDbAndQueueAndId(db, queue, id, options = {}) {
    return this.makeRequest(`${this.host}/internal/stats/events/failures/summaries/${db}/${queue}/${id}`, {
      ...options,
       method: 'DELETE',
    });
  }

}
